export default "__VITE_PUBLIC_ASSET__c3f4077f__"